export const perToEn = (s: string) => s.replace(/[۰-۹٠-٩]/g, (d) => `${'۰۱۲۳۴۵۶۷۸۹٠١٢٣٤٥٦٧٨٩'.indexOf(d) % 10}`);
export const thousandSeparator = (val: number | string) => val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
